import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MarkerAsyncAction } from '../store/marker.asyncAction';
import { MARKER_ACTION } from '../store/marker.slice';

/**
 * Payload Marker
 * @typedef {object} PayloadMarker
 * @property {string} name
 * @property {string} address
 * @property {number} id_desa
 * @property {number} id_kota
 * @property {string} latitude
 * @property {string} longitude
 * @property {string} siteName
 * @property {string} icon_color
 * @property {string} icon_type
 * @property {string} nama_desa
 * @property {string} nama_kota
 * @property {string} nama_kecamatan
 * @property {string} nama_provinsi
 * @property {number[]} coordinate
 * @property {number} id_provinsi
 * @property {number} id_kecamatan
 */

export const useMarker = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.features.GENSET.MARKER);
  const list = useMemo(() => state.ids.map((v) => state.entities[v]), [state.entities, state.ids]);
  const mapperListToDetail = (id) => state.entities[id];
  const status = useMemo(() => state.status, [state.status]);
  const message = useMemo(() => state.message, [state.message]);
  const meta = useMemo(() => state.meta, [state.meta]);

  /**
   * Marker Service
   * @param {object} query - query for get list marker
   * @param {object} query.meta - Meta for filter marker
   * @param {object} query.meta.filter
   * @param {string} query.meta.filter.name
   * @param {number} query.meta.page
   * @param {number} query.meta.limit
   * @param {object} query.meta.sort
   * @param {string} query.meta.sort.by
   * @param {string} query.meta.sort.name
   */
  const getList = (query) => dispatch(MarkerAsyncAction.getList({ query }));

  /**
   * @param {PayloadMarker} payload
   */
  const create = (payload) => dispatch(MarkerAsyncAction.create({ payload }));

  /**
   * @param {number} id
   * @param {PayloadMarker} payload
   */
  const update = (id, payload) => dispatch(MarkerAsyncAction.update({ id, payload }));

  /**
   * @param {number} id
   */
  const remove = (id) => dispatch(MarkerAsyncAction.delete({ id }));

  /**
   * @param {object} payload
   * @param {string[]} payload.status
   * @param {'IDLE'|'LOADING'|'SUCCESS'|'FAILED'} payload.type
   */
  const setStatus = (payload) => dispatch(MARKER_ACTION.setStatus(payload));
  const resetStatusAndMessage = () => dispatch(MarkerAsyncAction.resetStatusAndMessage({}));
  const removeAll = () => dispatch(MarkerAsyncAction.removeAll());


  return {
    list,
    mapperListToDetail,
    status,
    message,
    meta,
    state,
    getList,
    create,
    update,
    remove,
    resetStatusAndMessage,
    removeAll,
    setStatus,
  };
};
